import { getFaro } from "./faro";

export interface FaroSubmissionContext {
  faro_session_id: string | null;
  faro_trace_id: string | null;
}

export function getFaroSubmissionContext(): FaroSubmissionContext {
  const faro = getFaro();
  if (!faro) {
    return { faro_session_id: null, faro_trace_id: null };
  }

  return {
    faro_session_id: faro.api.getSession()?.id ?? null,
    faro_trace_id: faro.api.getTraceContext()?.trace_id ?? null,
  };
}
